import {Typography} from "@mui/material";
import React from "react";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => <>
    <Typography component="p">
        Suppliers that have only one parent supplier are considered standalone suppliers.
    </Typography>
</>
